// CSS Modules - component class name: ContactForm__

<template>
  <form :class="$style.container">
    <div class="columns">
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.name.$model"
          :label="config.labels.name.label"
          :boldLabel="true"
          :errorMessage="config.labels.name.errorMessage"
          :error="$v.formData.name.$error && $v.$dirty && isSubmitted"
          :originalValue="previousData.name && previousData.name !== '' ? previousData.name : null"
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.company.$model"
          :label="config.labels.company.label"
          :boldLabel="true"
          :errorMessage="config.labels.company.errorMessage"
          :error="$v.formData.company.$error && $v.$dirty && isSubmitted"
          :originalValue="previousData.company && previousData.company !== '' ? previousData.company : null"
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model="formData.department"
          :label="config.labels.department.label"
          :optionalLabel="config.labels.department.optionLabel"
          :error="false"
          :originalValue="previousData.department && previousData.department !== '' ? previousData.department : null"
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model="formData.streetNr"
          :label="config.labels.streetNr.label"
          :optionalLabel="config.labels.streetNr.optionLabel"
          :error="false"
          :originalValue="previousData.streetNr && previousData.streetNr !== '' ? previousData.streetNr : null"
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.zipCity.$model"
          :label="config.labels.zipCity.label"
          :boldLabel="true"
          :errorMessage="config.labels.zipCity.errorMessage"
          :error="$v.formData.zipCity.$error && $v.$dirty && isSubmitted"
          :originalValue="previousData.zipCity && previousData.zipCity !== '' ? previousData.zipCity : null"
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormSelect
          v-model.trim="$v.formData.country.$model"
          :label="config.labels.country.label"
          :errorMessage="config.labels.country.errorMessage"
          :error="$v.formData.country.$error && $v.$dirty && isSubmitted"
          :options="config.selectOptions"
          :initialOption="config.initialSelectOption"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model="formData.phone"
          :label="config.labels.phone.label"
          :optionalLabel="config.labels.phone.optionLabel"
          :error="false"
          :originalValue="previousData.phone && previousData.phone !== '' ? previousData.phone : null"
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
      <div class="column">
        <FormInput
          v-model="formData.fax"
          :label="config.labels.fax.label"
          :optionalLabel="config.labels.fax.optionLabel"
          :error="false"
          :originalValue="previousData.fax && previousData.fax !== '' ? previousData.fax : null"
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormInput
          v-model.trim="$v.formData.email.$model"
          :label="config.labels.email.label"
          :boldLabel="true"
          :errorMessage="config.labels.email.errorMessage"
          :error="$v.formData.email.$error && $v.$dirty && isSubmitted"
          :originalValue="previousData.email && previousData.email !== '' ? previousData.email : null"
          :formSubmitSwitch="formSubmitSwitch"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <FormTextarea
          v-model.trim="$v.formData.message.$model"
          :label="config.labels.message.label"
          :errorMessage="config.labels.message.errorMessage"
          :error="$v.formData.message.$error && $v.$dirty && isSubmitted"
          :rows="5"
          :columns="20"
        />
      </div>
    </div>
    <div class="columns">
      <div class="column has-text-right-tablet">
        <Button
          colour="blue"
          text="Senden"
          type="submit"
          :isForm="true"
          @close="handleSubmit"
        >
        </Button>
      </div>
    </div>
    <div :class="$style.serverError" v-if="serverError">{{ config.serverErrorMessage }}</div>
    <ReCaptcha :executeSwitch="executeSwitch" :submit="submit" />
  </form>
</template>

<script>
import { email, required } from "vuelidate/lib/validators";
import ReCaptcha from "../ReCaptcha/ReCaptcha";
import FormInput from "../FormInput/FormInput";
import FormSelect from "../FormSelect/FormSelect";
import FormTextarea from "../FormTextarea/FormTextarea";
import Button from "../Button/Button";
import axios from "axios";
import { contactFormUrl as formUrl } from "../../shared/globals";

const noPlaceholderValue = value => value.indexOf("...") === -1;

export default {
  name: "ContactForm",
  components: {
    ReCaptcha,
    Button,
    FormInput,
    FormSelect,
    FormTextarea
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formData: {
        name: "",
        company: "",
        department: "",
        streetNr: "",
        zipCity: "",
        country: "",
        phone: "",
        fax: "",
        email: "",
        message: "",
        domain: "",
        pageUrl: "",
        token: ""
      },
      previousData: {},
      isSubmitted: false,
      formSubmitSwitch: false,
      executeSwitch: false,
      showThankyou: false,
      serverError: false
    };
  },
  validations: {
    formData: {
      name: {
        required
      },
      company: {
        required
      },
      zipCity: {
        required
      },
      country: {
        required,
        noPlaceholderValue
      },
      email: {
        required,
        email
      },
      message: {
        required
      }
    }
  },
  mounted() {
    if (this.config.initialSelectOption) {
      this.formData.country = this.config.initialSelectOption;
    }
  },
  methods: {
    handleSubmit() {
      this.serverError = false;
      this.$v.$touch();
      this.isSubmitted = true;
      this.formSubmitSwitch = !this.formSubmitSwitch;
      if (!this.$v.$invalid) {
        this.executeSwitch = !this.executeSwitch;
      } else {
        this.previousData = JSON.parse(JSON.stringify(this.formData));
      }
    },
    submit(token) {
      this.formData.token = token;
      this.formData.domain = window.location.origin;
      this.formData.pageUrl = window.location.pathname;
      axios({
        url: formUrl,
        method: "post",
        data: this.formData,
        responseType: "json"
      })
        .then(response => {
          if (response.status === 200) {
            window.open(this.config.thankyouUrl, "_self");
          } else {
            this.serverError = true;
          }
        })
        .catch(error => {
          this.serverError = true;
          console.error(error);
        });
    }
  }
};
</script>

<style module lang="scss">
@import "./ContactForm.scss";
</style>
